<template>
  <div class="modal fade" id="projectVoteModal" tabindex="-1">
    <div class="modal-dialog modal-lg modal-dialog-scrollable">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Vote for Projects</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body">

          <project-voting
            v-if="isModalOpen"
            :showing-modal="true"
            :preselected-project="project"
            @votes-saved="closeModal"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProjectVoting from './ProjectVoting.vue'

export default {
  components: {
    ProjectVoting
  },

  props: {
    project: {
      type: Object,
      required: true
    },
    isModalOpen: {
      type: Boolean,
      required: true
    }
  },

  computed: {

  },

  methods: {
    closeModal() {
      this.$emit('votes-updated')
    }
  }
}
</script>
